(function () {
  const $ = (sel, root = document) => root.querySelector(sel);

  function init() {
    const sticky = $(".sticky-atc-bar");
    if (!sticky) return;

    const slot = $("[data-variant-picker-slot]", sticky);
    const home = $("[data-variant-picker-home]");
    if (!slot || !home) return;

    // Le bloc à téléporter = le contenu direct de "home"
    // (on déplace le node, pas une copie)
    const picker = home.firstElementChild;
    if (!picker) return;

    // placeholder pour garder la place en haut
    const ph = document.createElement("div");
    ph.setAttribute("data-variant-picker-placeholder", "");
    ph.style.height = getComputedStyle(picker).height;

    function isStickyVisible() {
      // adapte si ton thème utilise une autre classe que hidden
      return !sticky.classList.contains("hidden");
    }

    function moveToSticky() {
      if (slot.contains(picker)) return;
      home.insertBefore(ph, picker); // garde la hauteur
      slot.appendChild(picker);
    }

    function moveBackHome() {
      if (home.contains(picker)) return;
      home.appendChild(picker);
      ph.remove();
    }

    // Observe l’apparition de la sticky (classe hidden retirée)
    const mo = new MutationObserver(() => {
      if (isStickyVisible()) moveToSticky();
      else moveBackHome();
    });

    mo.observe(sticky, { attributes: true, attributeFilter: ["class"] });

    // état initial
    if (isStickyVisible()) moveToSticky();
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();


document.addEventListener("click", (e) => {
  const slot = document.querySelector(".sticky-bar-variant-slot");
  if (!slot) return;

  const btn = e.target.closest("[data-sticky-dropdown-button]");

  // 1) Clic sur le bouton : toggle + ferme les autres
  if (btn && btn.closest(".sticky-bar-variant-slot")) {
    const optionBlock = btn.closest(".product__option");
    if (!optionBlock) return;

    const isOpen = optionBlock.classList.toggle("is-open");
    btn.setAttribute("aria-expanded", isOpen ? "true" : "false");

    slot.querySelectorAll(".product__option.is-open").forEach((el) => {
      if (el !== optionBlock) {
        el.classList.remove("is-open");
        const b = el.querySelector("[data-sticky-dropdown-button]");
        if (b) b.setAttribute("aria-expanded", "false");
      }
    });

    return;
  }

  // 2) Clic ailleurs (hors d'un bloc option ouvert) : fermer
  // Si tu veux fermer même si on clique dans la sticky mais pas dans l'option, remplace la condition.
  const clickedInsideOpenOption = e.target.closest(".sticky-bar-variant-slot .product__option.is-open");
  if (clickedInsideOpenOption) return;

  slot.querySelectorAll(".product__option.is-open").forEach((el) => {
    el.classList.remove("is-open");
    const b = el.querySelector("[data-sticky-dropdown-button]");
    if (b) b.setAttribute("aria-expanded", "false");
  });
});

document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-sticky-color-dropdown-button]");
  if (!btn) return;

  const dropdown = btn.closest("[data-sticky-dropdown]");
  if (!dropdown) return;

  const content = dropdown.querySelector("[data-sticky-dropdown-content]");
  if (!content) return;

  const open = dropdown.classList.toggle("is-open");
  btn.setAttribute("aria-expanded", open ? "true" : "false");
});

document.addEventListener("click", (e) => {
  // fermeture au clic hors dropdown
  if (e.target.closest("[data-sticky-dropdown]")) return;
  document.querySelectorAll("[data-sticky-dropdown].is-open").forEach((dd) => {
    dd.classList.remove("is-open");
    const b = dd.querySelector("[data-sticky-color-dropdown-button]");
    if (b) b.setAttribute("aria-expanded", "false");
  });
});

document.addEventListener("click", (e) => {
  const btn = e.target.closest(".dropdown-ul");
  if (!btn) return;

  if (btn.classList.contains("is-active")) return;

  window.location.href = btn.dataset.productUrl;
});
